export const createError = (errorName, messageOrGetter, reasons) => {
  var _class;
  return {
    [errorName]: (_class = class extends Error {
      constructor(reason, context) {
        const messageArgs = context && 'messageArgs' in context ? context.messageArgs : [];
        const {
          details,
          originalError
        } = context || {};
        const message = typeof messageOrGetter === 'function' ? messageOrGetter(...messageArgs) : messageOrGetter;
        super(`${message} (Reason: ${reason})`);
        this.reason = reason;
        if (originalError instanceof Error) {
          this.originalError = originalError;
          this.cause = originalError;
          this.details = originalError.message;
        }
        if (typeof details === 'string') {
          this.details = details;
        }
      }
    }, _class.Reason = reasons, _class)
  }[errorName];
};